import { Dropdown, Menu, message } from 'antd';
import React from 'react';
import { useLocation } from 'react-router-dom';
import ShareIcon from '@/assets/images/header/share-icon.react.svg?react';
import { copy } from '@/infrastructure/clipboard';
import { TopMenuButton } from '@/presentation/layouts/header/button';

export const ShareButton = () => {
  const location = useLocation();

  const getCurrentUrl = (isIntranet: boolean) => {
    const currentPath = location.pathname;
    const currentSearch = location.search;
    const fullPath = `${currentPath}${currentSearch}`;

    if (isIntranet) {
      // 内网链接
      return `https://bugly.woa.com/v2${fullPath}`;
    }
    // 外网链接
    return `https://internal.bugly.qq.com/v2${fullPath}`;
  };

  const copyToClipboard = (text: string, linkType: string) => {
    try {
      copy(text);
      message.success(`已复制${linkType}到剪贴板`);
    } catch (err) {
      message.error('复制失败，请手动复制');
    }
  };

  const handleCopyIntranetLink = () => {
    const url = getCurrentUrl(true);
    copyToClipboard(url, '内网链接');
  };

  const handleCopyExtranetLink = () => {
    const url = getCurrentUrl(false);
    copyToClipboard(url, '外网链接');
  };

  const menu = (
    <Menu>
      <Menu.Item key="intranet" onClick={handleCopyIntranetLink}>
        复制内网链接
      </Menu.Item>
      <Menu.Item key="extranet" onClick={handleCopyExtranetLink}>
        复制外网链接
      </Menu.Item>
    </Menu>
  );

  return (
    <Dropdown overlay={menu} trigger={['click', 'hover']}>
      <div style={{ cursor: 'pointer' }}>
        <TopMenuButton onClick={() => {}}>
          <ShareIcon />
          <span>分享</span>
        </TopMenuButton>
      </div>
    </Dropdown>
  );
};

